import React, { useEffect, useCallback, useState} from 'react';
import Colors from 'components/Colors.js';
import OscillatorComponent from './OscillatorComponent.js';
import WaveformDropdown from './WaveformDropdown.js';
import {connect} from 'react-redux';
import FMHarmonicityModulation from "components/instruments/FMHarmonicityModulation.js"
import EffectParameterSlider from "components/effects/EffectParameterSlider.js"

const colors = new Colors();

const FMOperatorComponent = ({setSelectedNode, oscillator, sequencerEngine, instrument, color}) => { 
    return (
        <div className="fm-operator-component">
          <FMHarmonicityModulation
            color={color}
            setSelectedOsc={setSelectedNode}
            oscillator={oscillator}
            sequencerEngine={sequencerEngine}
            instrument={instrument}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FMOperatorComponent);
